import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  mr: {
    translation: {
      brand: "निर्मल धारा डेअरी",
      brandSub: "एलएलपी (LLP)",
      tagline: "आमच्या स्वतःच्या तंत्रशुद्ध शेतातून... थेट तुमच्या घरापर्यंत!",
      heroDesc: "निर्मल धारा फार्म्सवर आम्ही स्वतः संगोपन केलेल्या निरोगी म्हशींचे १००% शुद्ध, नैसर्गिक आणि प्रक्रिया न केलेले ताजे दूध पुरवतो.",
      exploreBtn: "उत्पादने पहा",
      contactBtn: "ऑर्डर / संपर्क",
      
      aboutTitle: "आमच्या शेताविषयी",
      aboutSubtitle: "उत्कृष्ट काळजी आणि अत्याधुनिक तंत्रज्ञानाचा मेळ",
      aboutText1: "निर्मल धारा डेअरी LLP मध्ये आम्ही कोणत्याही मध्यस्थांशिवाय आमच्या स्वतःच्या प्रशस्त फार्मवर म्हशींचे जतन व संगोपन करतो. म्हशींना दिला जाणारा नैसर्गिक आहार, स्वच्छ वातावरण आणि अत्याधुनिक मिल्किंग सिस्टीममुळे दुधाची गुणवत्ता उच्च दर्जाची राहते.",
      aboutText2: "आमच्या शेतातून काढलेले ताजे दूध कोणत्याही भेसळीशिवाय किंवा रासायनिक प्रक्रियेशिवाय काही तासांत तुमच्या दारापर्यंत पोहोचवले जाते.",

      processTitle: "फार्म ते होम: आमची सोपी कार्यपद्धती",
      step1Title: "१. स्वतःचे अत्याधुनिक फार्म",
      step1Desc: "नैसर्गिक व पोषक आहार देऊन काळजीपूर्वक जोपासलेल्या म्हशी.",
      step2Title: "२. ऑटोमेटेड हायजिनिक मिल्किंग",
      step2Desc: "मानवी स्पर्शाशिवाय अत्यंत स्वच्छ आणि सुरक्षित दूध संकलन.",
      step3Title: "३. क्विक चिल्ड कोल्ड चेन",
      step3Desc: "दूध ताजे राहण्यासाठी तात्काळ ४°C वर थंड केले जाते.",
      step4Title: "३. थेट घरोघरी मोफत वितरण",
      step4Desc: "दररोज सकाळी थेट आमच्या शेतातून तुमच्या घरापर्यंत.",

      productsTitle: "फार्म-फ्रेश उत्पादने",
      productsSubtitle: "१००% नैसर्गिक, पोषक आणि भेसळमुक्त",
      milk: "ताजे फार्म दूध",
      milkDesc: "आमच्या स्वतःच्या फार्मवरील म्हशींचे शुद्ध आणि दाट दूध.",
      ghee: "शुद्ध बिलोना साजूक तूप",
      gheeDesc: "पारंपारिक बिलोना पद्धतीने तयार केलेले सुगंधी आणि पौष्टिक तूप.",
      paneer: "मऊ मलाई पनीर",
      paneerDesc: "आमच्या ताज्या दुधापासून दररोज बनवले जाणारे अत्यंत मऊ पनीर.",
      curd: "घट्ट फार्म-फ्रेश दही",
      curdDesc: "नैसर्गिकरीत्या विरजलेले, प्रोबायोटिक समृद्ध ताजे दही.",

      whyTitle: "आमच्या शेतातील दुधाचे वैशिष्ट्य",
      q1Title: "१००% स्वतःचे फार्म",
      q1Desc: "दुधाच्या प्रत्येक थेंबावर आमचे पूर्ण नियंत्रण आणि हमी.",
      q2Title: "भेसळमुक्त व सुरक्षित",
      q2Desc: "नो प्रिव्हर्व्हेटिव्ह्ज, नो केमिकल्स — फक्त नैसर्गिक शुद्धता.",
      q3Title: "कडक प्रयोगशाळा चाचण्या",
      q3Desc: "दररोज स्निग्धता (Fat) आणि गुणवत्तेची संगणकीय चाचणी.",

      contactTitle: "आजच संपर्क साधा",
      contactSubtitle: "ताजे दूध आणि दुग्धजन्य पदार्थांच्या डिलिव्हरीसाठी संपर्क करा",
      phone: "फोन",
      phoneVal: "+९१ ९४०४९४११९९",
      email: "ईमेल",
      emailVal: "contact@nirmaldhara.in",
      address: "पत्ता",
      addressVal: "निर्मल धारा डेअरी एलएलपी, बालाजीनगर, भोकरदन, महाराष्ट्र - ४३१११४",
      viewOnMap: "Google Maps वर पहा",
      formName: "तुमचे नाव",
      formPhone: "मोबाइल नंबर",
      formMessage: "तुम्हाला कोणती उत्पादने हवी आहेत?",
      formSubmit: "चौकशी पाठवा",
      rights: "सर्व हक्क सुरक्षित.",
      followUs: "सोशल मीडिया"
    }
  },
  en: {
    translation: {
      brand: "Nirmal Dhara Dairy",
      brandSub: "LLP",
      tagline: "Directly From Our Own Farm to Your Doorstep",
      heroDesc: "We supply 100% pure, unadulterated, and fresh milk produced directly at our own high-tech eco-friendly dairy farm.",
      exploreBtn: "Explore Products",
      contactBtn: "Order / Contact",

      aboutTitle: "About Our Farm",
      aboutSubtitle: "Scientific Care, Happy Animals & Pure Milk",
      aboutText1: "At Nirmal Dhara Dairy LLP, we don't source milk from external vendors. Instead, we manage our own state-of-the-art cattle farm where buffaloes are fed organic green fodder and raised in stress-free conditions.",
      aboutText2: "From automated hygienic milking to quick-chill cold chains, we ensure that untampered farm-fresh milk reaches your doorstep within hours.",

      processTitle: "Farm-to-Door Process",
      step1Title: "1. Own Modern Farm",
      step1Desc: "Cattle cared for with organic feed and regular health checks.",
      step2Title: "2. Touchless Milking",
      step2Desc: "Automated milking parlor maintaining highest hygiene standards.",
      step3Title: "3. Instant Cold Chain",
      step3Desc: "Rapidly chilled to 4°C immediately after milking to lock freshness.",
      step4Title: "3. Direct Home Delivery",
      step4Desc: "Dispatched straight from our farm to your home every morning.",

      productsTitle: "Farm-Fresh Products",
      productsSubtitle: "100% Natural, Rich in Protein, Zero Chemicals",
      milk: "Fresh Farm Milk",
      milkDesc: "Pure, wholesome milk produced directly from our farm cattle.",
      ghee: "Pure Bilona Desi Ghee",
      gheeDesc: "Crafted using traditional Bilona method for rich aroma and nutrition.",
      paneer: "Fresh Soft Paneer",
      paneerDesc: "Handcrafted daily using our own farm-fresh pure milk.",
      curd: "Thick Natural Curd",
      curdDesc: "Naturally set, probiotic-rich thick curd and buttermilk.",

      whyTitle: "Why Choose Our Farm Direct Milk?",
      q1Title: "100% Single-Source Farm",
      q1Desc: "Complete quality control from cattle feed to final delivery.",
      q2Title: "Zero Preservatives",
      q2Desc: "No antibiotics, hormones, or chemical additives added ever.",
      q3Title: "Daily Quality Testing",
      q3Desc: "Continuous testing for fat, SNF, and purity levels.",

      contactTitle: "Get In Touch",
      contactSubtitle: "Contact us to start your daily farm-fresh delivery",
      phone: "Phone Number",
      phoneVal: "+91 9404941199",
      email: "Email Address",
      emailVal: "contact@nirmaldhara.in",
      address: "Location",
      addressVal: "Nirmal Dhara Dairy LLP, Balajinagar, Bhokardan, Maharashtra - 431114",
      viewOnMap: "View on Google Maps",
      formName: "Your Name",
      formPhone: "Mobile Number",
      formMessage: "Inquiry / Daily Delivery Requirement",
      formSubmit: "Submit Inquiry",
      rights: "All Rights Reserved.",
      followUs: "Social Media"
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'mr', // Marathi set as default
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  }
});

export default i18n;